/** leads/DmPreviewModal.tsx — DM 안내장 미리보기 (같은 탭, iframe 렌더 — CSP 회피) */
import React, { useRef } from 'react';

interface Props { html: string; corpName: string; onClose: () => void }

export default function DmPreviewModal({ html, corpName, onClose }: Props) {
  const frameRef = useRef<HTMLIFrameElement>(null);
  const doPrint = () => { try { frameRef.current?.contentWindow?.print(); } catch { /* noop */ } };
  const hideToolbar = () => { // 템플릿 내장 하단 버튼은 포털 전용 — 미리보기에선 모달 헤더가 대신함
    try { const d = frameRef.current?.contentDocument; if (d) { const st = d.createElement('style'); st.textContent = '.dm-toolbar{display:none!important}'; d.head.appendChild(st); } } catch { /* noop */ }
  };
  return (
    <div className="ld-modal-bg ld-root" onClick={onClose}>
      <div className="ld-modal dm-prev" onClick={(e) => e.stopPropagation()}>
        <div className="ld-modal-h">
          <div><span>{corpName} — DM 안내장</span><span className="pm-sub">발송 전 미리보기 · 인쇄하면 A4 안내장</span></div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="ld-btn pri" onClick={doPrint}>🖨 인쇄</button>
            <button className="ld-btn" onClick={onClose}>닫기</button>
          </div>
        </div>
        <iframe ref={frameRef} title="DM 미리보기" srcDoc={html} onLoad={hideToolbar} style={{ flex: 1, width: '100%', border: 0, background: '#fff', borderRadius: '0 0 14px 14px' }} />
      </div>
    </div>
  );
}
